import { MappedNotification } from 'common/header/notifications/Notifications.types';
import { NotificationIntlMessages } from 'src/components/common/header/translations/useNotificationsIntl';

export const getAuditReportTitle = (intl: NotificationIntlMessages): Partial<MappedNotification> => ({
  iconType: 'SUCCESS',
  title: intl.auditReportTitle
});
